import { Button } from "@/components/ui/button";
import IconProvider from "@/components/ui/IconProvider";

import { usePlatformTranslation } from '@/hooks/usePlatformTranslation';
interface BoldButtonProps {
  onFormat: (command: string, value?: string) => void;
}

export const BoldButton = ({ onFormat }: BoldButtonProps) => {
  const { t } = usePlatformTranslation();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-8 w-8 p-0 hover:bg-gray-100 text-gray-700 hover:text-gray-900 border-r border-gray-200"
      onClick={() => onFormat('bold')}
      title={t('platform.editor.bubblemenuhelpers.bold')}
    >
      <IconProvider iconstring="fa-bold" size={14} />
    </Button>
  );
}; 